const updateTypologyMutation = `
  mutation UpdateMarketplaceTypology($id: ID!, $fields: UpdateMarketplace_typologyFieldsInput) {
    updateMarketplace_typology(input: { id: $id, fields: $fields }) {
      marketplace_typology {
        objectId
        name
        icon {
          name
          url
        }
        cover {
          name
          url
        }
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default updateTypologyMutation;
